import './arkConfig.ts';
import { isDefined } from '@sgme/fp';
import { type } from 'arktype';

import { logger } from '@/components/SgwtBootstrap/logger.ts';
import { type WorkspaceForex, WorkspaceValidator } from '@/domain/WorkspaceForex/WorkspaceForex.ts';

export type ValidatedWorkspaceForex = Omit<WorkspaceForex, 'tiles'> & {
  tiles: (WorkspaceForex['tiles'][number] & { invalidSavedProduct?: boolean })[];
};

export function validateWorkspace(workspace: unknown): ValidatedWorkspaceForex | undefined {
  const savedProductTileIds = getSavedProductTileIds(workspace);
  const result = WorkspaceValidator(workspace);

  if (result instanceof type.errors) {
    logger.logError('Invalid workspace data: {errors_s}', result.toString());
    return undefined;
  }
  
  // Ensure that option have one default leg
  if (isDefined(result.products.option)) {
    for (const option of result.products.option) {
      if (option.properties.legs.length === 0) {
        option.properties.legs.push({ legId: `${option.tileId}/0`, legProductName: 'Vanilla' });
      }
    }
  }
  const invalidProductTileIds = savedProductTileIds.filter(
    (tileId) => !Object.values(result.products).some((products) => products.some((product) => product.tileId === tileId)),
  );
  return {
    ...result,
    tiles: result.tiles.map((tile) => ({
      ...tile,
      invalidSavedProduct: invalidProductTileIds.includes(tile.tileId) || undefined,
    })),
  };
}

function getSavedProductTileIds(workspace: unknown): string[] {
  if (!isRecord(workspace) || !isRecord(workspace.products)) {
    return [];
  }

  return Object.values(workspace.products).flatMap((products) => {
    if (!Array.isArray(products)) {
      return [];
    }
    return products.flatMap((product) => (isRecord(product) && typeof product.tileId === 'string' ? [product.tileId] : []));
  });
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
